__turbopack_context__.v({
  "active": "shop-module__GBzivq__active",
  "addToCartBtn": "shop-module__GBzivq__addToCartBtn",
  "badge": "shop-module__GBzivq__badge",
  "cartIcon": "shop-module__GBzivq__cartIcon",
  "categoryList": "shop-module__GBzivq__categoryList",
  "colorFilter": "shop-module__GBzivq__colorFilter",
  "filterBtn": "shop-module__GBzivq__filterBtn",
  "filterContainer": "shop-module__GBzivq__filterContainer",
  "filterIndicator": "shop-module__GBzivq__filterIndicator",
  "filterTitle": "shop-module__GBzivq__filterTitle",
  "heartIcon": "shop-module__GBzivq__heartIcon",
  "heroBanner": "shop-module__GBzivq__heroBanner",
  "heroContent": "shop-module__GBzivq__heroContent",
  "heroDescription": "shop-module__GBzivq__heroDescription",
  "heroGradient": "shop-module__GBzivq__heroGradient",
  "heroSubtitle": "shop-module__GBzivq__heroSubtitle",
  "heroTitle": "shop-module__GBzivq__heroTitle",
  "hoverButton": "shop-module__GBzivq__hoverButton",
  "imageContainer": "shop-module__GBzivq__imageContainer",
  "imageGlow": "shop-module__GBzivq__imageGlow",
  "mainContent": "shop-module__GBzivq__mainContent",
  "mobileFilterBar": "shop-module__GBzivq__mobileFilterBar",
  "pageTitle": "shop-module__GBzivq__pageTitle",
  "priceRow": "shop-module__GBzivq__priceRow",
  "productCard": "shop-module__GBzivq__productCard",
  "productCardContent": "shop-module__GBzivq__productCardContent",
  "productDescription": "shop-module__GBzivq__productDescription",
  "productImage": "shop-module__GBzivq__productImage",
  "productInfo": "shop-module__GBzivq__productInfo",
  "productName": "shop-module__GBzivq__productName",
  "productPrice": "shop-module__GBzivq__productPrice",
  "productsGrid": "shop-module__GBzivq__productsGrid",
  "radial": "shop-module__GBzivq__radial",
  "rating": "shop-module__GBzivq__rating",
  "ratingFilter": "shop-module__GBzivq__ratingFilter",
  "reviewCount": "shop-module__GBzivq__reviewCount",
  "shopContainer": "shop-module__GBzivq__shopContainer",
  "sidebar": "shop-module__GBzivq__sidebar",
  "sidebarContent": "shop-module__GBzivq__sidebarContent",
  "sidebarTitle": "shop-module__GBzivq__sidebarTitle",
  "sortFilter": "shop-module__GBzivq__sortFilter",
  "sortSelect": "shop-module__GBzivq__sortSelect",
  "stars": "shop-module__GBzivq__stars",
  "stock": "shop-module__GBzivq__stock",
  "topBar": "shop-module__GBzivq__topBar",
});
